import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import ApplyForm from './ApplyForm';

const ApplyDialog = ({
	as,
	episode,
	onHide,
	onSubmit,
	show,
}) => {
	const { t } = useTranslation();

	return <Modal className="apply-dialog" onHide={onHide} show={show}>
		<Modal.Header closeButton>
			<Modal.Title>
				{t('episodes.applyDialog.title')}
			</Modal.Title>
		</Modal.Header>
		<ApplyForm
			as={as}
			episode={episode}
			onCancel={onHide}
			onSubmit={onSubmit}
		/>
	</Modal>;
};

ApplyDialog.propTypes = {
	as: PropTypes.string,
	episode: PropTypes.shape({
	}),
	onHide: PropTypes.func,
	onSubmit: PropTypes.func,
	show: PropTypes.bool,
};

export default ApplyDialog;
